import { useEffect, useState } from "react";
import { updateUser } from "../../../services/userService";
import { useCookies } from "react-cookie";
import { useTranslation } from "react-i18next";

export default function ProfileDetails({ user }) {
  const { t } = useTranslation();
  const [cookie] = useCookies(["access_token"]);
  let initialName = `${user?.firstName}`;
  let initialSurname = `${user?.lastName}`;
  let initialPhone = user?.phone !== null ? `${user?.phone}` : "";
  const [firstName, setName] = useState("");
  const [lastName, setSurname] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [phoneError, setPhoneError] = useState(false);
  const [invalidPhoneError, setInvalidPhoneError] = useState(false);

  const validatePhoneNumber = (phoneNumber) => {
    const regex = /^(\+|0|00)[1-9][0-9 \-\(\)\.]{7,32}$/;
    return regex.test(phoneNumber);
  };

  useEffect(() => {
    if ((phone !== "" && validatePhoneNumber(phone)) || phone === "") {
      phoneError && setPhoneError(false);
      invalidPhoneError && setInvalidPhoneError(false);
    }
  }, [phone]);

  const [unlockButton, setUnlockButton] = useState(false);
  useEffect(() => {
    if (
      (firstName && firstName !== initialName) ||
      (lastName && lastName !== initialSurname) ||
      (phone && phone !== initialPhone && !phoneError && !invalidPhoneError)
    ) {
      setUnlockButton(true);
    } else {
      setUnlockButton(false);
    }
  }, [firstName, phone, lastName]);

  useEffect(() => {
    user?.firstName && setName(user?.firstName);
    user?.lastName && setSurname(user?.lastName);
    user?.email && setEmail(user?.email);
    user?.phone && setPhone(user?.phone);
    initialName = `${user?.firstName}`;
    initialSurname = `${user?.lastName}`;
    initialPhone = user?.phone !== null ? `${user?.phone}` : "";
  }, [user]);

  const handleUpdateUser = () => {
    if (phone !== "") {
      if (!validatePhoneNumber(phone)) {
        setPhoneError(true);
        setInvalidPhoneError(true);
        return;
      }
    }

    updateUser(user?.id, firstName, lastName, phone, cookie?.access_token);
  };
  return (
    <div className="profile-details">
      <div className="input-fields">
        <div className="input">
          <label>{t("name")}</label>
          <input
            type="text"
            value={firstName}
            onChange={(e) => {
              setName(e.target.value);
            }}
          />
        </div>
        <div className="input">
          <label>{t("surname")}</label>
          <input
            type="text"
            value={lastName}
            onChange={(e) => {
              setSurname(e.target.value);
            }}
          />
        </div>
        <div className="input">
          <label>{t("email")}</label>
          <input disabled type="email" value={email} />
        </div>
        <div className="input">
          <label>{t("number")}</label>
          <input
            className={phoneError && "error"}
            type="tel"
            value={phone}
            onChange={(e) => {
              setPhone(e.target.value);
            }}
          />
          {invalidPhoneError && (
            <p className="error-message">{t("phone-error")}</p>
          )}
        </div>
      </div>
      <div className="buttons">
        <button
          className={!unlockButton && "disabled"}
          disabled={!unlockButton}
          onClick={handleUpdateUser}
        >
          {t("save")}
        </button>
      </div>
    </div>
  );
}
